/**
 * localStorage-Helfer. Alle Schlüssel tragen das Präfix `zp.` — dieselbe
 * Handschrift wie `spg.` in webgis. Das Präfix ist kein Schmuck: auf einem
 * gemeinsamen Ursprung (eine Domain, mehrere Anwendungen) verhindert es, dass
 * sich zwei Anwendungen gegenseitig die Einstellungen überschreiben.
 *
 * Beide Funktionen schlucken JEDEN Fehler und geben den Ersatzwert zurück:
 * im privaten Fenster, bei vollem Speicher und bei gesperrten Website-Daten
 * wirft schon der blosse Zugriff. Eine Oberfläche darf daran nicht sterben —
 * sie verliert dann eben ihre Merkfähigkeit, mehr nicht.
 */

const PRAEFIX = "zp.";  // war "fb." in fragenbuero, "spg." in webgis

export function load<T>(key: string, fallback: T): T {
  try {
    const v = localStorage.getItem(PRAEFIX + key);
    return v === null ? fallback : (JSON.parse(v) as T);
  } catch {
    return fallback;
  }
}

export function save(key: string, val: unknown): void {
  try {
    localStorage.setItem(PRAEFIX + key, JSON.stringify(val));
  } catch {
    /* Kontingent voll oder privates Fenster — ignorieren */
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(PRAEFIX + key);
  } catch {
    /* s. o. */
  }
}
